// extracted by mini-css-extract-plugin
export default {"spinner-container":"eYVqDh","spinnerContainer":"eYVqDh","spinner":"wyOybg"};